#@export GliveBooking.Models.Price

class GliveBooking.Models.Price extends BookingV2.Models.Base

  getPrice: ->
    @get('price').amount

  getFormattedPrice: ->
    @get('price').formattedAmount

  getPriceCurrencyCode: ->
    @get('price').currencyCode

  getValue: ->
    @get('value').amount

  getFormattedValue: ->
    @get('value').formattedAmount

  getValueCurrencyCode: ->
    @get("value").currencyCode

  getDiscount: ->
    @get('discount')

  getSavings: ->
    @getValue() - @getPrice()
